var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"file-page__header",staticStyle:{"height":"100%"}},[_c('Breadcrumb',{attrs:{"crumbs":_vm.crumbs,"startIndex":0,"forceShowBackArrow":true,"maxItemWidth":'300'},on:{"change":function (ref) {
	var index = ref.index;
	var name = ref.name;
	var backCrumb = ref.backCrumb;

	return _vm.methods.changeBreadcrumbIndex(index, name, backCrumb);
}}}),_c('link-list',{attrs:{"isConsole":true,"linkQueryParams":_vm.linkQueryParams,"hideHeader":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }